export enum PickupPersonEnum {
  PARENT_1 = 'PARENT_1',
  PARENT_2 = 'PARENT_2',
  OTHER = 'OTHER'
}

export const pickupPersonOptionsMapping: Record<PickupPersonEnum, string> = {
  [PickupPersonEnum.PARENT_1]: 'Parent 1',
  [PickupPersonEnum.PARENT_2]: 'Parent 2',
  [PickupPersonEnum.OTHER]: 'Autre'
}
